import { render, staticRenderFns } from "./StatusDetail.vue?vue&type=template&id=e55ec242&scoped=true&"
import script from "./StatusDetail.vue?vue&type=script&lang=js&"
export * from "./StatusDetail.vue?vue&type=script&lang=js&"
import style0 from "./StatusDetail.vue?vue&type=style&index=0&id=e55ec242&prod&lang=scss&"
import style1 from "./StatusDetail.vue?vue&type=style&index=1&id=e55ec242&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55ec242",
  null
  
)

export default component.exports